import { render, staticRenderFns } from "./ContractWorkFacts.vue?vue&type=template&id=5cae6ab4"
import script from "./ContractWorkFacts.vue?vue&type=script&lang=js"
export * from "./ContractWorkFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports